import * as contentRange from "content-range";

class OnlineContainerResource {
    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource,
        configService
    ) {

        return headers => {
            return $resource(configService.contentApi.url + "/v1/sales/:id", { id: "@id" }, {
                update: {
                    method: "PATCH"
                },
                reset: {
                    method: "POST",
                    url: configService.contentApi.url + "/v1/sales/:id/purge"
                },
                setSaleConditions: {
                    method: "POST",
                    url: configService.contentApi.url + "/v1/sales/:id/sale_conditions"
                },
                deleteSaleConditions: {
                    method: "DELETE",
                    url: configService.contentApi.url + "/v1/sales/:id/sale_conditions"
                },
                createItem: {
                    method: "POST",
                    url: configService.contentApi.url + "/v1/sales/:id/items",
                    headers: headers || {}
                },
                getItems: {
                    method: "GET",
                    url: configService.contentApi.url + "/v1/sales/:id/items",
                    isArray: true,
                    headers: headers || {},
                    cancellable: true
                },
                getOnlineContainerLastBids: {
                    method: "GET",
                    url: configService.onlineApi.url + "/v1/sales/:id/last-bids",
                    isArray: true,
                    headers: headers || {},
                    cancellable: true,
                    params: {
                        canceled: false
                    }
                },
                countItems: {
                    method: "HEAD",
                    headers: headers || {},
                    url: configService.contentApi.url + "/v1/sales/:id/items",
                    transformResponse: (data, headersGetter) => {
                        // TODO : check if value is not null
                        const range = contentRange.parse(headersGetter("Content-Range"));
                        const totalFound = range && range.length;
                        return { count: totalFound };
                    }
                },
                publish: {
                    method: "POST",
                    url: configService.contentApi.url + "/v1/sales/:id/publish",
                    headers: headers || {}
                },
                getOnlineContainerCaution: {
                    method: "GET",
                    url: configService.contentApi.url + "/v1/sales/:id/online",
                    headers: headers || {}
                },
                updateOnlineContainerCaution: {
                    method: "PATCH",
                    url: configService.contentApi.url + "/v1/sales/:id/online",
                    headers: headers || {}
                }
            });
        };
    }

}

angular
    .module("thor.core.online-container.resource", [])
    .factory("onlineContainerResource", OnlineContainerResource);
